var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container_DefaultLayout"},[_c('div',{staticClass:"menu_DefaultLayout"},[_c('sidebar')],1),_c('div',{staticClass:"content_DefaultLayout"},[_c('layout-content')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }